/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/
import { parse, format } from 'date-fns'

export const getDate = date => format(parse(date, 'dd-MM-yyyy HH:mm', new Date()), 'dd.MM.yyyy')

export const iso8601WeekSettings = {
  weekStartsOn: 1,
  firstWeekContainsDate: 4,
}
